import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Dog, Cat, HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import pawBg from "./paw-background.png";

interface AnimalAvatarProps {
  animalId: string;
  photoUrl: string | null;
  name: string;
  species: string;
  className?: string;
  fallbackClassName?: string;
}

export function getAnimalPhotoSrc(animalId: string): string {
  return `/api/animals/${animalId}/photo`;
}

function getSpeciesIcon(species: string) {
  switch (species?.toUpperCase()) {
    case "DOG":
      return Dog;
    case "CAT":
      return Cat;
    default:
      return HelpCircle;
  }
}

function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function AnimalAvatar({
  animalId,
  photoUrl,
  name,
  species,
  className,
  fallbackClassName,
}: AnimalAvatarProps) {
  const SpeciesIcon = getSpeciesIcon(species);

  return (
    <Avatar key={photoUrl ?? "no-photo"} className={cn("h-10 w-10", className)} data-testid={`avatar-animal-${animalId}`}>
      {photoUrl && (
        <AvatarImage
          src={`${getAnimalPhotoSrc(animalId)}?v=${encodeURIComponent(photoUrl)}`}
          alt={name}
        />
      )}
      <AvatarFallback
        className={cn("relative overflow-hidden bg-muted", fallbackClassName)}
      >
        <img
          src={pawBg}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
        <SpeciesIcon className="relative h-3/5 w-3/5 text-white drop-shadow-md" />
      </AvatarFallback>
    </Avatar>
  );
}
